/**
 * @description Operating System strings
 */
export enum OperatingSystem {
	ANDROID = 'ANDROID',
	IOS = 'IOS',
	LINUX = 'LINUX',
	MAC_OS = 'MAC_OS',
	WINDOWS = 'WINDOWS',
	WINDOWS_10 = 'WINDOWS_10',
	WINDOWS_11 = 'WINDOWS_11',
	WINDOWS_7 = 'WINDOWS_7',
	WINDOWS_8 = 'WINDOWS_8',
	WINDOWS_8_1 = 'WINDOWS_8.1',
	WINDOWS_VISTA = 'WINDOWS_VISTA',
	WINDOWS_XP = 'WINDOWS_XP'
}